import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { action, API, controller } from "../../../../api/api";
import Details from "./Details";
import ReturnItems from "./ReturnItems";

const ViewReturnStock = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState();

  useEffect(() => {
    if (id) {
      setLoading(true);
      API(controller.StockReturn + action.GetDetailsById).getById(id, (res) => {
        setLoading(false);
        if (res && res.status === 200) setValue(res.result);
        else setValue({});
      });
    }

    return () => {};
  }, [id]);

  return !loading ? (
    value && value.id ? (
      <div className="flex flex-col gap-6">
        <Details {...{ value }} />
        <ReturnItems
          {...{
            value,
          }}
        />
      </div>
    ) : (
      "Data not found."
    )
  ) : (
    "Loading..."
  );
};

export default ViewReturnStock;
